import Dashboard from "pages/dashboard";
import Profile from "pages/profile";
import SignIn from "pages/sign-in";
import Shop from "components/Icons/Shop";
import Document from "components/Icons/Document";
import SignOut from "components/Icons/SignOut";
import CustomerSupport from "components/Icons/CustomerSupport";
import Blog from "components/Icons/Blog";
import Job from "components/Icons/Job";
import BlogPage from "pages/blogPage";
import JobPage from "pages/jobPage";
import SignOutPage from "pages/sign-out";
import BlogCategory from "components/Icons/BlogCategory";
import BlogCategoryPage from "pages/blogCategoryPage";
import JobCategoryPage from "pages/jobCategoryPage";
import BusinessEnquiryPage from "pages/businessEnquiryPage";
import { APP_CONSTANTS } from "App.constant";
import BusinessEnquiry from "components/Icons/BusinessEnquiry";

const routes = [
  {
    type: "collapse",
    name: "Dashboard",
    key: "dashboard",
    route: "/dashboard",
    icon: <Shop size="16px" />,
    component: <Dashboard />,
    noCollapse: true,
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.ALL,
  },
  {
    type: "title",
    title: "Business Section",
    key: "business-section",
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.ADMIN,
  },
  {
    type: "collapse",
    name: "Business Enquiry",
    key: "business-enquiry",
    route: "/business-enquiry",
    icon: <BusinessEnquiry size="16px" />,
    component: <BusinessEnquiryPage />,
    noCollapse: true,
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.ADMIN,
  },
  {
    type: "title",
    title: "SEO Section",
    key: "seo-section",
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.SEO,
  },
  {
    type: "collapse",
    name: "Blog Categories",
    key: "blog-categories",
    route: "/blog-categories",
    icon: <BlogCategory size="16px" />,
    component: <BlogCategoryPage />,
    noCollapse: true,
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.SEO,
  },
  {
    type: "collapse",
    name: "Blogs",
    key: "blog",
    route: "/blog",
    icon: <Blog size="16px" />,
    component: <BlogPage />,
    noCollapse: true,
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.SEO,
  },
  {
    type: "title",
    title: "HR Section",
    key: "hr-section",
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.HR,
  },
  {
    type: "collapse",
    name: "Job Categories",
    key: "job-categories",
    route: "/job-categories",
    icon: <BlogCategory size="16px" />,
    component: <JobCategoryPage />,
    noCollapse: true,
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.HR,
  },
  {
    type: "collapse",
    name: "Jobs",
    key: "job",
    route: "/job",
    icon: <Job size="24px" />,
    component: <JobPage />,
    noCollapse: true,
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.HR,
  },
  {
    type: "title",
    title: "Account Section",
    key: "account-section",
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.ALL,
  },
  {
    type: "collapse",
    name: "Profile",
    key: "profile",
    route: "/profile",
    icon: <CustomerSupport size="14px" />,
    component: <Profile />,
    noCollapse: true,
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.ALL,
  },
  {
    type: "collapse",
    name: "Sign In",
    key: "sign-in",
    route: "/",
    icon: <Document size="12px" />,
    component: <SignIn />,
    noCollapse: true,
    inSideBarMenu: false,
    isPublicMenu: false,
    access_type: APP_CONSTANTS.USER_ROLES.ALL,
  },
  {
    type: "collapse",
    name: "Log Out",
    key: "sign-out",
    route: "/sign-out",
    icon: <SignOut size="16px" />,
    component: <SignOutPage />,
    noCollapse: true,
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.ALL,
  },
  {
    type: "collapse",
    name: "Log Out From All",
    key: "sign-out-all",
    route: "/sign-out-all",
    icon: <SignOut size="16px" />,
    component: <SignOutPage logoutAll={true}/>,
    noCollapse: true,
    inSideBarMenu: true,
    isPublicMenu: true,
    access_type: APP_CONSTANTS.USER_ROLES.ALL,
  },
];

export default routes;
